import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCRoYTqnMBdRVj7TpY-L0tHa-_49eIHTb4",
  authDomain: "ly-crm.firebaseapp.com",
  projectId: "ly-crm",
  storageBucket: "ly-crm.firebasestorage.app",
  messagingSenderId: "9110340501",
  appId: "1:9110340501:web:0cdf62681d873451462c9c",
  measurementId: "G-15SDHWFV4D",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

export { auth, firestore, storage };
